export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CambiaNota.vue?vue&type=template&id=73a37429&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/CambiaNota.vue?vue&type=template&id=73a37429&scoped=true&
// module id = 803
// module chunks = 0